export default "__VITE_ASSET__DghSBTQi__"